import { Injectable } from "@angular/core";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";

@Injectable()
export class FileConverterService {

	constructor(private domSanitizer: DomSanitizer) { }

	toBase64String(arrayBuffer: ArrayBuffer): SafeUrl {

		const TYPED_ARRAY = new Uint8Array(arrayBuffer);
		const STRING_CHAR = TYPED_ARRAY.reduce((data1, byte) => {
			return data1 + String.fromCharCode(byte);
		}, '');
		const base64String = btoa(STRING_CHAR);

		return this.domSanitizer.bypassSecurityTrustUrl('data:image/jpg;base64, ' + base64String);
	}

	dataURItoBlob(dataURI: string) {

		const base64 = dataURI.replace(/^data:image\/(png|jpeg|jpg);base64,/, '');
		const byteString = atob(base64);
		const arrayBuffer = new ArrayBuffer(byteString.length);
		const int8Array = new Uint8Array(arrayBuffer);

		for (let i = 0; i < byteString.length; i++) {

			int8Array[i] = byteString.charCodeAt(i);
		}

		const blob = new Blob([int8Array], { type: 'image/png' });
		return blob;
	}
}